var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 138,
    viewBox: "0 0 196 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2602 1.25191C58.9765 11.4155 102.369 82.3384 64.042 97.724C40.9293 107.002 16.2682 101.231 3.9297 81.1098C-15.4366 49.5288 77.7227 23.0097 122.752 52.5469C167.782 82.084 188.958 139.849 215.09 136.479",
    stroke: "#E83E8C",
    strokeWidth: 1.51464,
    strokeDasharray: "5.3 5.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeTr);
export default __webpack_public_path__ + "static/media/shape-tr.f22081377059dd0245d631576b71b9ff.svg";
export { ForwardRef as ReactComponent };